$(document).ready(function() {

	window.onload = function() {
		// $('.thumb > a').click(function() {
		// 	$('.thumb > a').removeClass('active');
		// 	$(this).addClass('active');
		// });

		$('.product-media__featured-image').slick({	  
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  infinite: true,
		  asNavFor: '.gallery'
		});
		$('.gallery').slick({
		  slidesToShow: 4,
		  slidesToScroll: 1,
		  infinite: true,
		  asNavFor: '.product-media__featured-image',
		  arrows: false,
		  focusOnSelect: true
		});
	}; //end onload

	$('.content.product').on('variantChange', function() {
		console.log('variantChange!');
	});

	// disable Enter key on map form
	$(".shopify-product-form").keypress(function(e) {
		if (e.which == 13) {
			return false;
		}
	});

	// get to previous URL on PDP if request is on host domain
	$('.link--previous-page').each(function(e) {
		var currentShopUrl = $(this).attr('data-domain');
		if(document.referrer.indexOf(currentShopUrl) >= 0) {
	        $(this).attr('href', document.referrer)
	    }
	    else {
	    	$(this).css('display', 'none');
	    }
	});

	// currency selector
	function convertPrices(from, to) {
		Currency.convertAll(from, to, '.price', 'money_format');
		setTimeout(function() {
			Currency.convertAll(from, to, '.price', 'money_format');
		}, 1000);
	}

	var cookieCurrency = Currency.cookie.read();
	if (cookieCurrency == "EUR") {
		convertPrices("PLN", cookieCurrency);	
	}	

	Weglot.on("languageChanged", function(newLang, prevLang) {
	    if (newLang == "pl") {
			Currency.cookie.write('PLN');
			convertPrices('EUR', 'PLN');
		}else{
			Currency.cookie.write('EUR');
			convertPrices('PLN', 'EUR');
		}	
	});

	//cart FVAT
	function isValidNip(nip) {
      nip = nip.replace(/[\ \-]/gi, '');
      if(typeof nip !== 'string' || nip.length > 10)
        return false;

        let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
        let sum = 0;
        let controlNumber = parseInt(nip.substring(9, 10));
        let weightCount = weight.length;
        for (let i = 0; i < weightCount; i++) {
          sum += (parseInt(nip.substr(i, 1)) * weight[i]);
        }

        return sum % 11 === controlNumber;
    }

    function isValidZip(zip) {
        return /^([0-9]{2})(-[0-9]{3})?$/i.test(zip) && zip.length===6;
    }

    function companyVatValidation(e) {
      $('input[name="checkout"]').prop('disabled', false);
      let scope = $('#cartform');   
      if ($(scope).find('#cart__company-trigger').is(':checked') == true) {
        $(scope).find('.cart__company-fields > .input--text.input--required').each(function() {
          if ($(this).val() == "" ) {
            $(this).addClass('input--error');
          }else{
            $(this).removeClass('input--error');
          }       
        }).promise().done( function(){
          if ($(scope).find('.cart__company-fields > .input--text.input--required').hasClass('input--error')) {
            console.log('inputs error');
            $('input[name="checkout"]').prop('disabled', true);
            return false;
          }else{
            console.log('inputs OK');
          }
        });
        if (isValidNip($(scope).find('#cart__company-nip').val())) {        
          $(scope).find('#cart__company-nip').removeClass('input--error');
        }else{
          $(scope).find('#cart__company-nip').addClass('input--error');
          console.log('NIP error');
          $('input[name="checkout"]').prop('disabled', true);
          return false;
        }
        if (isValidZip($(scope).find('#cart__company-zip').val())) {        
          $(scope).find('#cart__company-zip').removeClass('input--error');
        }else{
          $(scope).find('#cart__company-zip').addClass('input--error');
          console.log('ZIP error');
          $('input[name="checkout"]').prop('disabled', true);
          return false;
        }
      } 

      return true;
    }

    function companyZipValidation() {
      $('#cart__company-zip').on('keydown', function(e){
        if( (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 8 ){
          if( e.keyCode !== 8 ){
            let val = $(this).val();
            if( val.length >= 6 )
              e.preventDefault();
            if( val.length === 2 )
              $(this).val(val + '-');
          }
        } else {
          e.preventDefault();
        }
      });
    }
    companyZipValidation();

    $('#cart__company-trigger').change(function() {
      cartCompanyTrigger();
    });

    function cartCompanyTrigger() {
      if ($('#cart__company-trigger').is(':checked') == false) {
        $('.cart__company-fields').css('display', 'none');
        $('input[name="checkout"]').prop('disabled', false);
      }else{
        $('.cart__company-fields').css('display', 'block');
        console.log(companyVatValidation());
        if (companyVatValidation() === false) {
          $('input[name="checkout"]').prop('disabled', true);
        }      
      }
    }
    cartCompanyTrigger();

    $('.cart__company-fields > .input--text').on('input',function(e){
      companyVatValidation();
    });

	
});